<template>
  <CurrencyInput
    class="sw form-control"
    v-bind="$attrs"
    locale="NL-nl"
    :currency="currency"
    :value="selected" @input="$value => $emit('input', $value)"
  />
</template>
<script>
import { CurrencyInput } from 'vue-currency-input'

export default {
  name: 'lg-number',
  components: { CurrencyInput },
  props: {
    value: Number,
    isMoney: { type: Boolean, default: false }
  },
  computed: {
    selected() {
      return this.value
    },
    currency() {
      return this.isMoney ? 'BRL' : null
    }
  },
}
</script>
